import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { signal, state } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'
import { t } from '@billes/translator-client'

export default connect(
  {
    client: state`app.client.name`,
    hasTerms: state`app.client.hasTerms`,
    showTerms: signal`startPage.onShowTerms`
  },
  class Footer extends Component {
    onTermsClicked(e) {
      e.preventDefault()
      e.stopPropagation()
      const { showTerms } = this.props
      showTerms()
    }

    render() {
      const { client, hasTerms } = this.props

      return (
        <div className={css(styles.footer)}>
          <div className={css(styles.companyInfo)}>
            <span>
              {t('bms.app.build', {
                tag: process.env.REACT_APP_BUILD_TAG || process.env.NODE_ENV
              })}
            </span>
          </div>
          <div className={css(styles.copyrightInfo)}>
            © Copyright {client}
            {hasTerms ? (
              <span>
                {' | '}
                <span
                  className={css(styles.termsLink)}
                  onClick={e => this.onTermsClicked(e)}
                >
                  {t('bms.terms.termsOfUse')}
                </span>
              </span>
            ) : null}
          </div>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Footer/footer.js